interface HighlightFeatureConstructorProps {
  title: string;
  description: string;
  icon: string;
}

class HighlightFeature {
  constructor(public _: HighlightFeatureConstructorProps) {}

  static fromJson(json: any) {
    return new HighlightFeature({
      title: json.title || "",
      description: json.description || "",
      icon: json.icon || "",
    });
  }

  toJson() {
    const res = {
      title: this._.title,
      description: this._.description,
      icon: this._.icon,
    } as any;
    return res;
  }
}

export { HighlightFeature };
